<template>
  <div ref="searchDiv">
    <el-form ref="form" :model="form" :inline="true" style="text-align: left;padding-top: 20px;">
      <el-form-item label="题目编号" label-width="80px">
        <el-input v-model="form.problemGuid" style="width: 150px;"></el-input>
      </el-form-item>
      <el-form-item label="主题号" label-width="60px">
        <el-input v-model="form.problemMain" style="width: 100px;"></el-input>
      </el-form-item>
      <el-form-item label="关键词" label-width="60px">
        <el-input v-model="form.keywords" style="width: 150px;"></el-input>
      </el-form-item>
      <el-form-item label="标题" label-width="60px">
        <el-input v-model="form.title" style="width: 150px;"></el-input>
      </el-form-item>
      <el-form-item label="其他" label-width="40px">
        <el-input v-model="form.qt" style="width: 150px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-col :span="13">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="8">
          <el-button @click="searchAll">全部</el-button>
        </el-col>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        form: {
          problemMain: '0',
          problemGuid: '',
          keywords: '',
          title: '',
          qt: ''
        }
      }
    },
    methods: {
      search () {
        console.log('problemSearch->search()')
        this.$emit('search', this.form)
      },
      searchAll () {
        console.log('problemSearch->searchAll()')
        this.form = {
          problemMain: '',
          problemGuid: '',
          keywords: '',
          title: '',
          qt: ''
        }
        this.search()
      },
      getHeight () {
        return this.$refs.searchDiv.offsetHeight
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// problemSearch.vue?22435e47